module.exports = __webpack_public_path__ + "static/media/404.94c6437b.jpg";